module.exports = __webpack_public_path__ + "static/media/bg-none.2dde560a.png";